import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'
import { Role } from './role'
import { roleActions } from './role.actions'
import { RoleService } from './role.service'

import * as fromRole from './role.reducer'

@Injectable()
export class RoleEffects extends ResourceEffects<Role> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public roleService: RoleService
  ) {
    super(fromRole.FEATURE_NAME, roleService, roleActions, actions$)
  }
}
